module.exports = __webpack_public_path__ + "img/patrick.d484f814.png";